import { MutationTree } from 'vuex'
import { NotificationType } from './types'

export const mutations: MutationTree<NotificationType> = {
  setSubscription(state, payload) {
    state.subscription = payload
  },
  newNotification(state, payload) {
    // state.newNotifications.push(payload)
    state.newNotifications = [payload]
  },
  removeNotificationsByIndex(state, index) {
    state.newNotifications.splice(index, 1)
  },
  setUnreadNotifications(state, payload) {
    state.unreadNotificationsCount = payload
  },
  setOneUnreadNewNotifications(state){
    state.unreadNotificationsCount++
  }
}
